class pdpUpsellItem extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll(".color-swatch");

    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", this.handleImageChange.bind(this));
    });

  }

  handleImageChange(event) {
    let titleProduct = this.querySelector(".span-tittle-extra p").innerText;
    const images = this.querySelectorAll(".img-cart");
    if(titleProduct == 'Bamboo Compression Socks'){
      var variantId = event.target.previousElementSibling.name.slice(0, -3).trim();
    }else{
      var variantId = event.target.previousElementSibling.name.trim();
    }
    images.forEach((image) => {
      if (image.getAttribute("data-variant-id") == variantId) {
        image.style.display = "block";
      } else {
        image.style.display = "none";
      }
    });
  }
}

customElements.define("pdp-upsell-item", pdpUpsellItem);
